export var defaultConfig = {
    schemaID: '',
    show: {
        sidebar: false,
        info: true,
        servers: true,
        operations: true,
        messages: true,
        schemas: true,
        errors: true,
    },
    sidebar: {
        showOperations: 'byOperationsTags',
    },
};
//# sourceMappingURL=default.js.map